export default "__VITE_ASSET__BJX5RwaW__"